import { render, staticRenderFns } from "./platform_brands.vue?vue&type=template&id=aa12b628&scoped=true&"
import script from "./platform_brands.vue?vue&type=script&lang=js&"
export * from "./platform_brands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa12b628",
  null
  
)

export default component.exports